import { useMemo } from 'react'
import { useDebounce } from 'use-debounce'

import { spaceEveryThousand } from '~/bootcamp/Activities/Multiplication/MultiBy/constants'
import { useRewardStatsQuery } from '~/redux/apis/user-stats-api'
import { useAppSelector } from '~/redux/hooks'

import { selectRewardsStatsFilter } from '../redux/statistics.slice'
import { APIExecutionStepsType } from '../types/common.types'

import { formatRewardsStats } from '../utils/format-stat.utils'
import { getFilterDates } from '../utils/get-filter-date.utils'

interface ReturnType {
  chest: {
    opened: number
    total: number
  }
  gems: number
  kudos: string
  xp: string
  APIExecutionSteps: APIExecutionStepsType
}

export default function useRewardsStats({ familyMemberId }: { familyMemberId?: number }): ReturnType {
  const timeFilter = useAppSelector(selectRewardsStatsFilter)

  const filter = useMemo(() => {
    const [startDate, endDate] = getFilterDates(timeFilter)

    return {
      startDate: startDate?.toISOString(),
      endDate: endDate?.toISOString(),
    }
  }, [timeFilter])

  const [debouncedFilter] = useDebounce(filter, 500)

  const { data: rewardsStatsAPI, ...APIExecutionSteps } = useRewardStatsQuery({ ...debouncedFilter, familyMemberId })
  const { gems, chest, ...rewardsStats } = formatRewardsStats(rewardsStatsAPI)

  const xp = spaceEveryThousand(rewardsStats.xp || 0)
  const kudos = spaceEveryThousand(rewardsStats.kudos || 0)

  return {
    xp,
    kudos,
    gems,
    chest,
    APIExecutionSteps,
  }
}
